/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Variables_SubtitleInputs */



/**
* | output |
* | --- |
* | "Select the boxes to initialize" |
*
* @param {Reset_Variables_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reset_variables_subtitle = /** @type {((inputs?: Reset_Variables_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Variables_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select the boxes to initialize")
	return /** @type {LocalizedString} */ ("Choisir les box à initialiser")
});